import { Route, Routes } from "react-router-dom";
import { JybeBusinessPage } from "./JybeBusinessPage";
import { Subscribers } from "./Subscribers";
function App() {
    return (
        <Routes>
            <Route path="/subscribers" element={<Subscribers />} />
            <Route path="/" element={<JybeBusinessPage />} />
        </Routes>
    )
}

export default App;